var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FieldError, FieldHint, FormLabel, TextInput, } from '..';
export function TextField(_a) {
    var id = _a.id, name = _a.name, label = _a.label, hint = _a.hint, error = _a.error, required = _a.required, placeholder = _a.placeholder, formLabelProps = _a.formLabelProps, value = _a.value, onChange = _a.onChange, textInputProps = _a.textInputProps;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormLabel, __assign({}, formLabelProps, { htmlFor: id, required: required, error: !!error }), label),
        React.createElement(TextInput, __assign({}, textInputProps, { id: id, name: name, value: value, placeholder: placeholder, onChange: onChange, error: !!error })),
        error && React.createElement(FieldError, null, error),
        hint && React.createElement(FieldHint, null, hint)));
}
//# sourceMappingURL=index.js.map